import { DefaultSelection } from "@components/ScenarioTree"
import { GraphDto } from "@custom-types/graphs"
import CreateScenarioModeButtons, {
  CreateScenarioModeButtonsProps,
} from "@features/scenarioDesign/GraphActionBar/CreateScenarioButtons"
import SelectBaseGraph from "@features/scenarioDesign/GraphActionBar/SelectBaseGraph"
import StartModeButtons from "@features/scenarioDesign/GraphActionBar/StartModeButtons"
import { ViewRunsModeButtonsProps } from "@features/scenarioDesign/GraphActionBar/ViewRunsModeButtons"
import { PageMode } from "@features/scenarioDesign/ScenarioDesignPage"
import { ArrowBack } from "@mui/icons-material"
import { Grid, IconButton, Tooltip } from "@mui/material"

type GraphActionBarProps = {
  familyKey: string
  defaultSelection: DefaultSelection | undefined
  onBaseGraphChange: (baseGraph: GraphDto) => void
  onChangeMode: (newMode: PageMode) => void
  mode: PageMode
  createScenarioModeButtonsProps: CreateScenarioModeButtonsProps
  viewRunsModeButtonsProps: ViewRunsModeButtonsProps
}

const GraphActionBar = ({
  familyKey,
  defaultSelection,
  mode,
  onChangeMode,
  onBaseGraphChange,
  createScenarioModeButtonsProps,
  viewRunsModeButtonsProps,
}: GraphActionBarProps) => {
  if (!familyKey) return

  return (
    <Grid container wrap="nowrap" justifyContent="space-between" gap={1}>
      <Grid item>
        <SelectBaseGraph
          familyKey={familyKey}
          onChange={onBaseGraphChange}
          defaultSelection={defaultSelection}
        />
      </Grid>
      <Grid container item xs gap={1} wrap="nowrap" sx={{ justifyContent: "flex-end" }}>
        {mode !== PageMode.Start && (
          <Grid item>
            <Tooltip title="Back">
              <IconButton onClick={() => onChangeMode(PageMode.Start)}>
                <ArrowBack />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        {mode === PageMode.Start && <StartModeButtons onChangeMode={onChangeMode} />}
        {mode === PageMode.CreateScenario && (
          <CreateScenarioModeButtons {...createScenarioModeButtonsProps} />
        )}
      </Grid>
    </Grid>
  )
}

export default GraphActionBar
